module.exports = __webpack_public_path__ + "images/806952e523f79830613886d5712cc387-logo_white.png";